var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16V16H0z",
    transform: "translate(-140 -736) translate(140 733) translate(0 3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C4CCE4",
    d: "M6.667 12c1.23 0 2.362-.423 3.264-1.125l2.931 2.93.943-.942-2.931-2.931C11.577 9.029 12 7.897 12 6.667c0-2.941-2.393-5.334-5.333-5.334-2.941 0-5.334 2.393-5.334 5.334C1.333 9.607 3.726 12 6.667 12zm0-9.333c2.206 0 4 1.794 4 4s-1.794 4-4 4-4-1.794-4-4 1.794-4 4-4z",
    transform: "translate(-140 -736) translate(140 733) translate(0 3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C4CCE4",
    d: "M7.608 5.724c.253.253.392.588.392.943h1.333c0-.71-.277-1.38-.782-1.886-1.01-1.008-2.76-1.008-3.768 0l.941.944c.507-.505 1.38-.504 1.884-.001z",
    transform: "translate(-140 -736) translate(140 733) translate(0 3)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.5ae94c6ef551c60dcd32a8854cc88150.svg";
export { ForwardRef as ReactComponent };